export default "<p>main-layout works!</p>\n";